import { render, staticRenderFns } from "./SelectInjection.vue?vue&type=template&id=132bee7e&"
import script from "./SelectInjection.vue?vue&type=script&lang=js&"
export * from "./SelectInjection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports